import { Link, useNavigate } from '@tanstack/react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { InventoryCreateInput, InventoryImageInput } from '@ncc/shared';
import { InventoryForm, type InventoryFormValues } from '../components/InventoryForm';
import { api } from '../lib/api';

export function NewListing() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Draft autosave used to run here on an 8s timer and a new listing was
  // PATCHed onto whatever draft it had left behind. With the timer gone a new
  // listing is always a single create.
  const finalize = useMutation({
    mutationFn: async ({
      values,
      images,
    }: {
      values: InventoryFormValues;
      images: InventoryImageInput[];
    }) => api.createInventory({ ...values, images } as InventoryCreateInput),
    onSuccess: (created) => {
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
      navigate({ to: '/edit/$id', params: { id: String(created.id) } });
    },
  });

  return (
    <>
      <header className="toolbar">
        <h2 style={{ margin: 0 }}>New Inventory</h2>
        <span className="grow" />
        <Link to="/">
          <button className="ghost">Cancel</button>
        </Link>
      </header>

      <div className="card">
        <InventoryForm
          submitLabel="Create inventory"
          onSubmit={async (values, images) => {
            await finalize.mutateAsync({ values, images });
          }}
        />
      </div>

      {finalize.isError ? (
        <div className="toast">Create failed: {String(finalize.error)}</div>
      ) : null}
    </>
  );
}
